import MUIDataTable from 'mui-datatables';
import React from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { Link } from 'react-router-dom';
import Toggle from 'react-toggle';
import { getComfortList , updateComfert,DeleteCarComfort } from '../../../actions/homeAction';
import { FaEdit } from 'react-icons/fa'

const CarModel = () => {
	
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getComfortList())
	},[])

	const handleStatusChange = (Id,active)=>{
		var data ={
			comfortId: Id,
			active : !active
		}
		dispatch(updateComfert(data))
	}
	const HandleDelete = ( ID )=>{
		if(ID){
		dispatch(DeleteCarComfort(ID))
		}
	}

	const comfortList = useSelector(state => state.home.comfortList)?.response

	console.log("comfortList", comfortList);
  const carModelList = []
  let columns = [];

		columns = [
			{
				name: 'comfort',
				label: 'Comfort Name',
				options: {
					filter: false,
					sort: true,
				},
			},
			{
				name: 'comfortAr',
				label: 'Comfort Name Ar',
				options: {
					filter: false,
					sort: true,
				},
			},

			{
				name: 'priority',
				label: 'Priority',
				options: {
					filter: false,
					sort: true,
				},
			},
			{
				name: 'active',
				label: 'Status',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (active, tableMeta) => {
						var Id = tableMeta.rowData[2];
						return (
							<Toggle
								id={'status_' + Id}
								defaultChecked={active}
								value={active}
								onChange={()=>handleStatusChange(Id, active)}
							/>
						);
					},
				},
			},
			{
				name: 'comfortId',
				label: 'Action',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (comfortId) => {
						return (
							<div>
								<Link to={`/CarDetail/Comfort/Update/${comfortId}?`}><FaEdit style={{fontSize: '1.4rem'}} /></Link>
								<span className='delBTN' onClick={()=>HandleDelete(comfortId)}><MdOutlineDeleteOutline style={{fontSize: '1.4rem', marginLeft:"1rem"}} /></span>
							</div>
						);
					},
				},
			},

		];
    
		const options = {
			filter: false,
			viewColumns: false,
			print: false,
			download: false,
			selectableRows: 'none',
			textLabels: {
				body: {
					// noMatch: this.state.isSaving
					// 	? 'Loading data..!'
					// 	: 'Sorry, No Users Found',
					toolTip: 'Sort',
					columnHeaderTooltip: column => `Sort for ${column.label}`,
				},
			},
		};
  return (
    <div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										<Link
											to={`/CarDetail/Comfort/Add`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											Add Comfort
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											{carModelList !== undefined ? (
												<MUIDataTable
													title={`Comfort`}
													className='table-responsive'
													data={comfortList}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
											{/* </MuiThemeProvider> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  )
}

export default CarModel